import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { handleOnDropFile } from 'app/_utils/general-utils';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';

declare const $: any;

@Component({
    selector: 'app-import-budget', templateUrl: './quotation-import-budget.component.html', styleUrls: ['./quotation-import-budget.component.scss'],
    standalone: false
})
export class BuyerCreateQuotationImportBudgetComponent {
    @ViewChild('templateImportBudgetComponent') template: TemplateRef<any>;
    modalRef: BsModalRef;

    @Output() onOrcamentoFileUpload = new EventEmitter<File>();

    constructor(private modalService: BsModalService) { }

    async close(): Promise<void> {
        this.modalRef.hide()
    }

    public onDrop($event): void {
        $event.preventDefault();

        var result = handleOnDropFile($event);

        this.onOrcamentoFileUpload.emit(result[0]);
    }

    public onDragOver($event: Event): void {
        $event.preventDefault();
    }

    open() {
        let options: ModalOptions = { class: 'custom-modal modal-sm', backdrop: 'static', keyboard: false };
        this.modalRef = this.modalService.show(this.template, options);
    }

    openFileSelection() {
        $("#input").click()
    }

    public stopDrag($event: Event): void {
        $event.preventDefault();
        $event.stopPropagation();
    }

    async uploadFile($event) {
        this.onOrcamentoFileUpload.emit($event.target.files[0])
    }
}
